import {get,post} from './httpApi';
import {getUserId,getShopId} from '@/utils/auth'
/*用户端：订单列表*/
export function allOrder(data=null){
    return get('/order/allOrder',{
        ...data,
        userId:getUserId()
    })
}
/*用户：订单详情*/
export function findOrderInfo(data=null){
    return get('/order/findOrderInfo',data)
}
/*商家端：订单详情*/
export function findOrderInfoForShop(data=null){
    return get('/order/findOrderInfoForShop',data)
}
/*催单接口*/
export function allPushContent(data=null){
    return post('/order/allPushContent',data)
}
/*创建普通商品订单*/
export function createOrder(data=null){
    return post('/order/createOrder',data)
}
/*用户确认收货*/
export function userCheckOver(data=null){
    return post('/order/userCheckOver',data)
}
/*用户发起售后*/
export function returnOrderApply(data=null){
    return post('/order/returnOrderApply',data)
}
/*商家端：订单列表*/
export function allOrderForShop(data=null){
    return get('/order/allOrderForShop',{
        ...data,
        shopId:getShopId()
    })
}
/*店铺填写单号确认发货*/
export function sendOrder(data=null){
    return  post('/order/sendOrder',{
        ...data,
        shopId:getShopId()
    })
}
/*店铺拒绝售后*/
export function returnOrderNo(data=null){
    return post('/order/returnOrderNo',data)
}
/*店铺确认售后*/
export function returnOrder(data=null){
    return post('/order/returnOrder',data)
}
/*店铺取消订单*/
export function delForUser(data=null){
    return post('/order/delForUser',data)
}
/**
 *
 * 拒绝线下支付订单
 * @param status 2同意 3拒绝
 * @param shopId
 * @param orderId
 * @return
 */
export function applyOnline(orderId){
    return post('/order/applyOnline',{
        userId:getUserId(),
        orderId
    })
}
/**
 * 线下支付订单
 * @return
 */
export function statusOnline(data=null){
    return post('/order/statusOnline',{
        ...data,
        shopId:getShopId()
    })
}